import { useLocation } from 'react-router-dom';
import {
  AccountSettingsIcon,
  NotificationsSettingsIcon,
  ProfileSettingsIcon,
  WorkPreferencesIcon,
  FAQIcon,
  CompanyLogoIcon,
} from 'assets';
import * as S from './styled';

const headerData = {
  'profile-settings': {
    title: 'Profile Settings',
    subTitle: 'Keep your profile accurate and current.',
    icon: <ProfileSettingsIcon />,
  },
  'work-preferences': {
    title: 'Work Preferences',
    subTitle:
      'Set your job preferences and work history \n to better represent your background and career goals.',
    icon: <WorkPreferencesIcon />,
  },
  'account-settings': {
    title: 'Account Settings',
    subTitle: 'Manage your login credentials and keep your account secure.',
    icon: <AccountSettingsIcon />,
  },
  'notifications-settings': {
    title: 'Notifications Settings',
    subTitle: 'Customize how you receive job alerts and platform updates.',
    icon: <NotificationsSettingsIcon />,
  },
  'company-memberships': {
    title: 'Company Memberships',
    subTitle: 'Manage your company affiliations and verify your work email.',
    icon: <CompanyLogoIcon />,
  },
  'help-center': {
    title: 'FAQ',
    subTitle: 'Got questions? \n We’ve got answers.',
    icon: <FAQIcon />,
  },
  test: {
    title: 'FAQ',
    subTitle: 'Got questions? \n We’ve got answers.',
    icon: <FAQIcon />,
  },
};

const ProfileRightBlockHeader = () => {
  const { pathname } = useLocation();
  const pathnameKey = pathname.substring(pathname.lastIndexOf('/') + 1);
  const { title, subTitle, icon } = headerData[pathnameKey];

  return (
    <S.RightBlockHeader>
      <S.HeaderTextBlock>
        <S.HeaderTitle component="h4">{title}</S.HeaderTitle>
        <S.HeaderSubTitle>{subTitle}</S.HeaderSubTitle>
      </S.HeaderTextBlock>
      {icon}
    </S.RightBlockHeader>
  );
};

export default ProfileRightBlockHeader;
